import { render, staticRenderFns } from "./BaseTabBox.vue?vue&type=template&id=fb962fb6&scoped=true"
import script from "./BaseTabBox.vue?vue&type=script&lang=js"
export * from "./BaseTabBox.vue?vue&type=script&lang=js"
import style0 from "./BaseTabBox.vue?vue&type=style&index=0&id=fb962fb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb962fb6",
  null
  
)

export default component.exports